function pad(n: number): string {
  return String(n).padStart(2, '0')
}

export function formatDate(isoString: string): string {
  const d = new Date(isoString)
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
}

export function formatDateTime(isoString: string, opts?: { autoHideTime?: boolean }): string {
  const d = new Date(isoString)
  const datePart = `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
  if (opts?.autoHideTime && d.getHours() === 0 && d.getMinutes() === 0) return datePart
  return `${datePart} ${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export function formatDateShort(isoString: string): string {
  const d = new Date(isoString)
  const now = new Date()
  if (d.getFullYear() === now.getFullYear()) {
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}`
  }
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`
}

export function formatPostTime(isoString: string): string {
  const now = Date.now()
  const then = new Date(isoString).getTime()
  const diffMs = now - then
  const diffMin = Math.floor(diffMs / 60_000)
  const diffHr = Math.floor(diffMin / 60)

  if (diffMin < 1) return 'just now'
  if (diffMin < 60) return `${diffMin}m`
  if (diffHr < 24) return `${diffHr}h`

  const d = new Date(isoString)
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  const timeStr = `${pad(d.getHours())}:${pad(d.getMinutes())}`

  if (d.toDateString() === today.toDateString()) return `Today at ${timeStr}`
  if (d.toDateString() === yesterday.toDateString()) return `Yesterday at ${timeStr}`
  return formatDateShort(isoString)
}
